export default {
  MuiRadio: {
    styleOverrides: {
      root: {
        color: '#D9D9D9', // 未選取狀態的顏色
        transition: '0.2s ease-in-out',
        '& > span > svg': {
          fontSize: '1rem'
        },
        '&.Mui-checked': {
          color: '#007aff'
        },
        '&.Mui-disabled': {
          color: '#BDBDBD !important'
        },
        '&:hover': {
          backgroundColor: 'rgba(31, 134, 255, 0.2)',
          transition: '0.2s ease-in-out'
        }
      },
      colorPrimary: {
        color: '#0075FE'
      }
    }
  }
};
